import React from "react";
import clsx from "clsx";
import { CSVLink } from "react-csv";

import Dropdown from "../../../atoms/Dropdown";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import { ISimpleTeachingMaterial, IBreadcrumbsLink } from "../../../state";
import DownloadButton from "../../../atoms/DownloadButton";

import styles from "./DownloadCSV.module.scss";

export type Props = {
  links: IBreadcrumbsLink[];
  dataCSV: string[][];
  teaching_materials: ISimpleTeachingMaterial[];
  nameClass: string;
  onDownLoadData: (teaching_material_id: number, lesson_id: number) => void;
  goBack: () => void;
};

export const DownloadCSV: React.FC<Props> = ({
  links,
  teaching_materials,
  onDownLoadData,
  goBack,
  dataCSV,
}) => {
  const [
    teachingMaterial,
    setTeachingMaterial,
  ] = React.useState<ISimpleTeachingMaterial>();
  const [lessonID, setLessonID] = React.useState<number | null>();
  const linkCSV = React.useRef<
    CSVLink & HTMLAnchorElement & { link?: HTMLAnchorElement }
  >(null);

  React.useEffect(() => {
    if (!!teaching_materials.length) {
      setTeachingMaterial(teaching_materials[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teaching_materials]);

  React.useEffect(() => {
    setLessonID(null);
  }, [teachingMaterial]);

  React.useEffect(() => {
    if (
      linkCSV &&
      !!teachingMaterial &&
      !!lessonID &&
      linkCSV.current!.props.data.length !== 0
    ) {
      setTimeout(() => {
        linkCSV.current!.link!.click();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCSV]);

  return (
    <>
      <TeacherHeader links={links} />
      <div className={styles.downloadCSV}>
        <div className={styles.btnBack} onClick={goBack}>
          くクラス選択に戻る
        </div>
        <Dropdown
          className={clsx(styles.dropdown, styles.dropTeachingMaterial)}
          options={teaching_materials.map(material => ({
            value: material.id,
            label: `${material.name} ${material.title}`,
          }))}
          onChange={(value: number) =>
            setTeachingMaterial(
              teaching_materials.filter(
                teaching_material => teaching_material.id === value,
              )[0],
            )
          }
        />
        <Dropdown
          className={styles.dropdown}
          placeholder="データを選択してください"
          options={
            teachingMaterial
              ? teachingMaterial.lessons!.map(lesson => ({
                  value: lesson.id,
                  label: `${lesson.name} ${lesson.title}`,
                }))
              : []
          }
          onChange={(value: number) => setLessonID(value)}
        />

        <DownloadButton
          className="ms-auto"
          disabled={!!teachingMaterial && !!lessonID ? false : true}
          onClick={() => {
            onDownLoadData(teachingMaterial!.id!, lessonID!);
          }}
        >
          ダウンロード
        </DownloadButton>
        <CSVLink
          filename="download.csv"
          data={dataCSV}
          uFEFF={true}
          hidden={true}
          ref={linkCSV}
        />
      </div>
    </>
  );
};

export default DownloadCSV;
